// Le rendu d'un message : des blocs sobres, des liens pour les références.
// Les liens passent par `/aller/…`, qui retrouve l'identifiant : le modèle
// cite une référence, pas une URL.
import { Link } from 'react-router';
import { blocs } from './rendu.js';

function Ligne({ morceaux }) {
  return morceaux.map((m, i) => {
    const cle = `${m.type}-${i}`;
    if (m.type === 'gras') return <strong key={cle}>{m.valeur}</strong>;
    if (m.type === 'devis') return <Link key={cle} to={`/aller/devis/${encodeURIComponent(m.cible)}`}>{m.valeur}</Link>;
    if (m.type === 'piece') return <Link key={cle} to={`/aller/piece/${m.cible}`}>{m.valeur}</Link>;
    return <span key={cle}>{m.valeur}</span>;
  });
}

export function MessageAssistant({ texte }) {
  return (
    <div className="assistant-message__texte">
      {blocs(texte).map((b, i) => {
        if (b.type === 'titre') return <p key={i} className="assistant-message__titre"><Ligne morceaux={b.morceaux} /></p>;
        if (b.type === 'paragraphe') return <p key={i}><Ligne morceaux={b.morceaux} /></p>;
        const Liste = b.ordonnee ? 'ol' : 'ul';
        return (
          <Liste key={i}>
            {b.items.map((item, j) => <li key={j}><Ligne morceaux={item} /></li>)}
          </Liste>
        );
      })}
    </div>
  );
}

export default MessageAssistant;
